import Rarity from "../../helper/Rarity";
import IngredientCategory from "../../helper/IngredientCategory";

export default {
    ABOMINATION_LYMPH: {
        item: 'Abomination Lymph',
        category: IngredientCategory.QUEBRITH,
        rarity: Rarity.RARE,
        cost: 152,
        weight: 0.1,
    },
    ALLSPICE_ROOT: {
        item: 'Allspice Root',
        category: IngredientCategory.AETHER,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 18,
        weight: 0.1,
    },
    ALP_SALIVA: {
        item: 'Alp Saliva',
        category: IngredientCategory.HYDRAGENUM,
        DC: 15,
        rarity: Rarity.UNCOMMON,
        cost: 145,
        weight: 0.1,
    },
    ARACHAS_CHITIN: {
        item: 'Arachas Chitin',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.RARE,
        cost: 106,
        weight: 5,
    },
    ARACHAS_EYES: {
        item: 'Arachas Eyes',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 95,
        weight: 0.5,
    },
    ARACHAS_VENOM: {
        item: 'Arachas Venom',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.RARE,
        cost: 76,
        weight: 0.5,
    },
    ARCHESPORE_JUICE: {
        item: 'Archespore Juice',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.UNCOMMON,
        cost: 38,
        weight: 0.1,
    },
    ARCHESPORE_TENDRILS: {
        item: 'Archespore Tendrils',
        category: IngredientCategory.QUEBRITH,
        rarity: Rarity.UNCOMMON,
        cost: 44,
        weight: 0.5,
    },



    BALISSE_FRUIT: {
        item: 'Balisse Fruit',
        category: IngredientCategory.VITRIOL,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 8,
        weight: 0.1,
    },
    BALISSE_LEAVES: {
        item: 'Balisse Leaves',
        category: IngredientCategory.QUEBRITH,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 8,
        weight: 0.1,
    },
    BARBEGAZI_FUR: {
        item: 'Barbegazi Fur',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.UNCOMMON,
        cost: 21,
        weight: 0.1,
    },
    BARGHEST_ESSENCE: {
        item: 'Barghest Essence',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.UNCOMMON,
        cost: 36,
        weight: 0.1,
    },
    BARLEY: {
        item: 'Barley',
        category: IngredientCategory.VITRIOL,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 9,
        weight: 0.1,
    },
    BEAR_FAT: {
        item: 'Bear Fat',
        category: IngredientCategory.REBIS,
        rarity: Rarity.COMMON,
        cost: 90,
        weight: 0.5,
    },
    BERBERCANE_FRUIT: {
        item: 'Berbercane Fruit',
        category: IngredientCategory.AETHER,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 9,
        weight: 0.1,
    },
    BES_HORN: {
        item: 'Bes Horn',
        category: IngredientCategory.FULGUR,
        DC: 18,
        maxAmount: 2,
        rarity: Rarity.RARE,
        cost: 166,
        weight: 1,
    },
    BOAR_TUSKS: {
        item: 'Boar Tusks',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.COMMON,
        cost: 82,
        weight: 0.1,
    },
    BOHUN_UPAS_POISON: {
        item: 'Bohun Upas Poison',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.RARE,
        cost: 200,
        weight: 0.1,
    },
    BOTCHLING_BLOOD: {
        item: 'Botchling Blood',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.RARE,
        cost: 66,
        weight: 0.1,
    },
    BOTCHLING_BONES: {
        item: 'Botchling Bones',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 55,
        weight: 0.1,
    },
    BOTCHLING_BRAIN: {
        item: 'Botchling Brain',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.RARE,
        cost: 154,
        weight: 0.1,
    },
    BOTCHLING_EAR: {
        item: 'Botching Ear',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 100,
        weight: 0.1,
    },
    BOTTLE_OF_SPIRITS: {
        item: 'Bottle Of Spirits',
        category: IngredientCategory.OTHER,
        rarity: Rarity.EVERYDAY,
    },
    BRUXA_BLOOD: {
        item: 'Bruxa Blood',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.RARE,
        cost: 97,
        weight: 0.1,
    },
    BRYONIA: {
        item: 'Bryonia',
        category: IngredientCategory.CAELUM,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 8,
        weight: 0.1,
    },
    BULLVORE_BLOOD: {
        item: 'Bullvore Blood',
        category: IngredientCategory.REBIS,
        rarity: Rarity.RARE,
        cost: 85,
        weight: 0.1,
    },
    BULLVORE_BRAIN: {
        item: 'Bullvore Brain',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 150,
        weight: 1,
    },
    BULLVORE_EYES: {
        item: 'Bullvore Eyes',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.RARE,
        cost: 87,
        weight: 0.5,
    },
    BURDOK_ROOT: {
        item: 'Burdok Root',
        category: IngredientCategory.VERMILION,
        DC: 16,
        rarity: Rarity.COMMON,
        maxAmount: 6,
        cost: 32,
        weight: 0.1,
    },


    CALCIUM_EQUUM: {
        item: 'Calcium Equum',
        category: IngredientCategory.VITRIOL,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 12,
        weight: 0.1,
    },
    CELANDINE: {
        item: 'Celandine',
        category: IngredientCategory.REBIS,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 8,
        weight: 0.1,
    },
    COCKATRICE_CARAPACE: {
        item: 'Cockatrice Carapace',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 75,
        weight: 2,
    },
    COCKATRICE_STOMACH: {
        item: 'Cockatrice Stomach',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.RARE,
        cost: 92,
        weight: 1,
    },
    COCKATRICE_TAIL_FEATHERS: {
        item: 'Cockatrice Tail Feathers',
        category: IngredientCategory.AETHER,
        rarity: Rarity.RARE,
        cost: 135,
        weight: 0.1,
    },
    CORTINARIUS: {
        item: 'Cortinarius',
        category: IngredientCategory.HYDRAGENUM,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 18,
        weight: 0.1,
    },
    CROWS_EYE: {
        item: 'Crow\'s Eye',
        category: IngredientCategory.VITRIOL,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 17,
        weight: 0.1,
    },
    CRYSTALLIZED_ESSENCE: {
        item: 'Crystallized Essence',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 292,
        weight: 0.1,
    },
    CYCLOPS_BONES: {
        item: 'Cyclops\' Bones',
        category: IngredientCategory.AETHER,
        rarity: Rarity.RARE,
        cost: 87,
        weight: 4,
    },
    CYCLOPS_BRAIN: {
        item: 'Cyclops\' Brain',
        category: IngredientCategory.REBIS,
        rarity: Rarity.RARE,
        cost: 136,
        weight: 2,
    },
    CYCLOPS_EYE: {
        item: 'Cyclops\' Eye',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.RARE,
        cost: 159,
        weight: 1,
    },
    CYCLOPS_TONGUE: {
        item: 'Cyclops Tongue',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 90,
        weight: 1,
    },



    DOG_TALLOW: {
        item: 'Dog Tallow',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.COMMON,
        cost: 10,
        weight: 0.1,
    },
    DRAGON_BLOOD: {
        item: 'Dragon Blood',
        category: IngredientCategory.REBIS,
        rarity: Rarity.RARE,
        cost: 250,
        weight: 1,
    },
    DRAGON_TAIL: {
        item: 'Dragon Tail',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 310,
        weight: 4,
    },
    DRAGON_TEARS: {
        item: 'Dragon Tears',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 276,
        weight: 0.1,
    },
    DRAGON_TEETH: {
        item: 'Dragon Teeth',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 192,
        weight: 1,
    },
    DROWNER_BRAIN: {
        item: 'Drowner Brain',
        category: IngredientCategory.REBIS,
        rarity: Rarity.UNCOMMON,
        cost: 80,
        weight: 1,
    },
    DROWNER_TONGUE: {
        item: 'Drowner Tongue',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.RARE,
        cost: 86,
        weight: 0.5,
    },
    DUCAL_WATER: {
        item: 'Ducal Water',
        category: IngredientCategory.QUEBRITH,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 20,
        weight: 0.1,
    },
    DWARVEN_IMMORTELLE: {
        item: 'Dwarven Immortelle',
        category: IngredientCategory.FULGUR,
        DC: 18,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 75,
        weight: 0.1,
    },



    ELEMENTAL_STONE: {
        item: 'Elemental Stone',
        category: IngredientCategory.QUEBRITH,
        rarity: Rarity.RARE,
        cost: 134,
        weight: 0.5,
    },
    ENDREGA_EMBRYO: {
        item: 'Endrega Embryo',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 55,
        weight: 1.5,
    },
    ENDREGA_SALIVA: {
        item: 'Endrega Saliva',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.UNCOMMON,
        cost: 38,
        weight: 0.1,
    },
    ESSENCE_OF_DEATH: {
        item: 'Essence of Death',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 155,
        weight: 0.1,
    },
    ESSENCE_OF_FIRE: {
        item: 'Essence of Fire',
        category: IngredientCategory.SOL,
        rarity: Rarity.UNCOMMON,
        cost: 46,
        weight: 0.1,
    },
    ESSENCE_OF_WATER: {
        item: 'Essence of Water',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 46,
        weight: 0.1,
    },
    ESSENCE_OF_WRAITH: {
        item: 'Essence of Wraith',
        category: IngredientCategory.AETHER,
        rarity: Rarity.RARE,
        cost: 95,
        weight: 0.1,
    },



    FIEND_DUNG: {
        item: 'Fiend Dung',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.RARE,
        cost: 106,
        weight: 1,
    },
    FIENDS_EYE: {
        item: 'Fiend\'s Eye',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 149,
        weight: 0.5,
    },
    FOGLET_ESSENCE: {
        item: 'Foglet Essence',
        category: IngredientCategory.AETHER,
        rarity: Rarity.UNCOMMON,
        cost: 43,
        weight: 0.1,
    },
    FOGLET_TEETH: {
        item: 'Foglet Teeth',
        category: IngredientCategory.REBIS,
        rarity: Rarity.RARE,
        cost: 40,
        weight: 0.1,
    },
    FOOLS_PARSLEY: {
        item: 'Fool\'s Parsley',
        category: IngredientCategory.QUEBRITH,
        DC: 10,
        maxAmount: 12,
        rarity: Rarity.EVERYDAY,
        cost: 2,
        weight: 0.1,
    },
    FRIGHTENER_CLAWS: {
        item: 'Frightener Claws',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 205,
        weight: 5,
    },
    FRIGHTENER_EYES: {
        item: 'Frightener Eyes',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 192,
        weight: 0.1,
    },



    GARKIN_SALIVA: {
        item: 'Garkin Saliva',
        category: IngredientCategory.QUEBRITH,
        rarity: Rarity.RARE,
        cost: 70,
        weight: 0.1,
    },
    GHOUL_CLAWS: {
        item: 'Ghoul Claws',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.RARE,
        cost: 60,
        weight: 1,
    },
    GHOUL_MARROW: {
        item: 'Ghoul Marrow',
        category: IngredientCategory.QUEBRITH,
        rarity: Rarity.RARE,
        cost: 80,
        weight: 0.5,
    },
    GIANT_CENTIPEDE_DISCHARGE: {
        item: 'Giant Centipede Discharge',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.UNCOMMON,
        cost: 40,
        weight: 0.1,
    },
    GIANT_CENTIPEDE_MANDIBLES: {
        item: 'Giant Centipede Mandibles',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.RARE,
        cost: 48,
        weight: 0.5,
    },
    GINATIA_PETALS: {
        item: 'Ginatia Petals',
        category: IngredientCategory.AETHER,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 17,
        weight: 0.1,
    },
    GLUSTYWORP_STOMACH: {
        item: 'Glustyworp Stomach',
        category: IngredientCategory.CAELUM,
        DC: 15,
        rarity: Rarity.UNCOMMON,
        cost: 96,
        weight: 0.5,
    },
    GODLING_EYES: {
        item: 'Godling Eyes',
        category: IngredientCategory.AETHER,
        rarity: Rarity.RARE,
        cost: 55,
        weight: 0.1,
    },
    GOLEM_HEART: {
        item: 'Golem Heart',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 167,
        weight: 1,
    },
    GRAVE_HAG_EAR: {
        item: 'Grave Hag Ear',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 134,
        weight: 0.1,
    },
    GRAVE_HAG_TONGUE: {
        item: 'Grave Hag Tongue',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.RARE,
        cost: 80,
        weight: 0.5,
    },
    GREEN_MOLD: {
        item: 'Green Mold',
        category: IngredientCategory.CAELUM,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 8,
        weight: 0.1,
    },
    GRIFFIN_EGG: {
        item: 'Griffin Egg',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.RARE,
        cost: 150,
        weight: 1,
    },
    GRIFFIN_FEATHER: {
        item: 'Griffin Feather',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.RARE,
        cost: 148,
        weight: 0.1,
    },



    HAG_TEETH: {
        item: 'Hag Teeth',
        category: IngredientCategory.REBIS,
        rarity: Rarity.RARE,
        cost: 90,
        weight: 0.1,
    },
    HAN_FIBER: {
        item: 'Han Fiber',
        category: IngredientCategory.REBIS,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 17,
        weight: 0.1,
    },
    HARPY_EGGS: {
        item: 'Harpy Eggs',
        category: IngredientCategory.QUEBRITH,
        rarity: Rarity.UNCOMMON,
        cost: 50,
        weight: 0.5,
    },
    HARPY_FEATHERS: {
        item: 'Harpy Feathers',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.UNCOMMON,
        cost: 28,
        weight: 0.1,
    },
    HARPY_TALONS: {
        item: 'Harpy Talons',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.UNCOMMON,
        cost: 40,
        weight: 0.1,
    },
    HELLEBORE_PETALS: {
        item: 'Hellebore Petals',
        category: IngredientCategory.AETHER,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 19,
        weight: 0.1,
    },
    HIGHER_VAMPIRE_FANGS: {
        item: 'Higher Vampire Fangs',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 250,
        weight: 0.1,
    },
    HONEYSUCKLE: {
        item: 'Honeysuckle',
        category: IngredientCategory.QUEBRITH,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 21,
        weight: 0.1,
    },



    INFUSED_DUST: {
        item: 'Infused Dust',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 146,
        weight: 0.1,
    },



    KNOCKER_HAIR: {
        item: 'Knocker Hair',
        category: IngredientCategory.QUEBRITH,
        rarity: Rarity.RARE,
        cost: 33,
        weight: 0.1,
    },
    KNOCKER_TEETH: {
        item: 'Knocker Teeth',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.RARE,
        cost: 46,
        weight: 0.1,
    },
    KNOCKER_TOES: {
        item: 'Knocker Toes',
        category: IngredientCategory.REBIS,
        rarity: Rarity.RARE,
        cost: 62,
        weight: 0.1,
    },



    LESHEN_BONE: {
        item: 'Leshen Bone',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 92,
        weight: 1,
    },
    LESHEN_FIBER: {
        item: 'Leshen Fiber',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.RARE,
        cost: 106,
        weight: 0.1,
    },
    LESHEN_RESIN: {
        item: 'Leshen Resin',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.RARE,
        cost: 140,
        weight: 0.1,
    },
    LIGHT_ESSENCE: {
        item: 'Light Essence',
        category: IngredientCategory.SOL,
        rarity: Rarity.UNCOMMON,
        cost: 43,
        weight: 0.1,
    },
    LUNAR_SHARDS: {
        item: 'Lunar Shards',
        category: IngredientCategory.REBIS,
        DC: 18,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 91,
        weight: 0.1,
    },



    MANDRAKE_ROOT: {
        item: 'Mandrake Root',
        category: IngredientCategory.VERMILION,
        DC: 18,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 65,
        weight: 0.1,
    },
    MANTICORE_FANGS: {
        item: 'Manticore Fangs',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.RARE,
        cost: 132,
        weight: 0.1,
    },
    MANTICORE_HORN: {
        item: 'Manticore Horn',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 120,
        weight: 1,
    },
    MANTICORE_STOMACH: {
        item: 'Manticore Stomach',
        category: IngredientCategory.QUEBRITH,
        rarity: Rarity.RARE,
        cost: 189,
        weight: 2,
    },
    MANTICORE_WING_MEMBRANES: {
        item: 'Manticore Wing Membranes',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 145,
        weight: 2,
    },
    MARI_LWYD_SKULL: {
        item: 'Mari Lwyd Skull',
        category: IngredientCategory.HYDRAGENUM,
        DC: 18,
        rarity: Rarity.RARE,
        maxAmount: 1,
        cost: 200,
        weight: 2,
    },
    MISTLETOE: {
        item: 'Mistletoe',
        category: IngredientCategory.HYDRAGENUM,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 8,
        weight: 0.1,
    },



    NAEZAN_SALTS: {
        item: 'Naezan Salts',
        category: IngredientCategory.AETHER,
        rarity: Rarity.RARE,
        cost: 146,
        weight: 0.1,
    },
    NEKKER_CLAW: {
        item: 'Nekker Claw',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.UNCOMMON,
        cost: 40,
        weight: 0.5,
    },
    NEKKER_HEART: {
        item: 'Nekker Heart',
        category: IngredientCategory.REBIS,
        rarity: Rarity.UNCOMMON,
        cost: 30,
        weight: 0.5,
    },
    NEKKER_TEETH: {
        item: 'Nekker Teeth',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.UNCOMMON,
        cost: 30,
        weight: 0.1,
    },



    OPTIMA_MATER: {
        item: 'Optima Mater',
        category: IngredientCategory.QUEBRITH,
        DC: 18,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 100,
        weight: 0.1,
    },



    PEARL: {
        item: 'Pearl',
        category: IngredientCategory.AETHER,
        DC: 20,
        maxAmount: 2,
        rarity: Rarity.RARE,
        cost: 100,
        weight: 0.1,
    },
    PHOENIX_ASH: {
        item: 'Phoenix Ash',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 94,
        weight: 0.1,
    },
    PHOENIX_FEATHERS: {
        item: 'Phoenix Feathers',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 176,
        weight: 0.1,
    },
    PHOSPHORUS: {
        item: 'Phosphorus',
        category: IngredientCategory.VERMILION,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 20,
        weight: 0.5,
    },
    PLUMARD_STOMACH: {
        item: 'Plumard Stomach',
        category: IngredientCategory.AETHER,
        rarity: Rarity.UNCOMMON,
        cost: 30,
        weight: 0.1,
    },



    QUICKSILVER_SOLUTION: {
        item: 'Quicksilver Solution',
        category: IngredientCategory.AETHER,
        DC: 18,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 77,
        weight: 0.1,
    },



    ROTFIEND_BLOOD: {
        item: 'Rotfiend Blood',
        category: IngredientCategory.REBIS,
        rarity: Rarity.UNCOMMON,
        cost: 30,
        weight: 0.1,
    },
    ROTFIEND_LIVER: {
        item: 'Rotfiend Liver',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.UNCOMMON,
        cost: 42,
        weight: 0.5,
    },



    SCLERODERM: {
        item: 'Scleroderm',
        category: IngredientCategory.AETHER,
        DC: 10,
        maxAmount: 12,
        rarity: Rarity.EVERYDAY,
        cost: 5,
        weight: 0.1,
    },
    SEWANT_MUSHROOMS: {
        item: 'Sewant Mushrooms',
        category: IngredientCategory.VITRIOL,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 17,
        weight: 0.1,
    },
    SHAELMAAR_DUST: {
        item: 'Shaelmaar Dust',
        category: IngredientCategory.REBIS,
        rarity: Rarity.RARE,
        cost: 79,
        weight: 0.1,
    },
    SHAELMAAR_HAIR: {
        item: 'Shaelmaar Hair',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.RARE,
        cost: 100,
        weight: 0.1,
    },
    SIREN_VOCAL_CHORD: {
        item: 'Siren Vocal Chord',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 65,
        weight: 0.1,
    },
    SLYZARD_SCALES: {
        item: 'Slyzard Scales',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 82,
        weight: 3,
    },
    SLYZARD_TALONS: {
        item: 'Slyzard Talons',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.RARE,
        cost: 69,
        weight: 0.5,
    },
    SLYZARD_VOCAL_CORDS: {
        item: 'Slyzard Vocal Cords',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.RARE,
        cost: 99,
        weight: 0.1,
    },
    SPECTER_DUST: {
        item: 'Specter Dust',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.UNCOMMON,
        cost: 30,
        weight: 0,
    },
    SUCCUBUS_HEART: {
        item: 'Succubus Heart',
        category: IngredientCategory.VERMILION,
        rarity: Rarity.RARE,
        cost: 95,
        weight: 0.5,
    },
    SUCCUBUS_HORN: {
        item: 'Succubus Horn',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.RARE,
        cost: 87,
        weight: 0.5,
    },
    SULFUR: {
        item: 'Sulfur',
        category: IngredientCategory.QUEBRITH,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 14,
        weight: 0.1,
    },
    SYLVAN_HOOF: {
        item: 'Sylvan Hoof',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 75,
        weight: 1,
    },
    SYLVAN_HORN: {
        item: 'Sylvan Horn',
        category: IngredientCategory.QUEBRITH,
        rarity: Rarity.RARE,
        cost: 80,
        weight: 0.5
    },



    TROLL_HIDE: {
        item: 'Troll Hide',
        category: IngredientCategory.VITRIOL,
        rarity: Rarity.RARE,
        cost: 147,
        weight: 4.5,
    },
    TROLL_LIVER: {
        item: 'Troll Liver',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 87,
        weight: 1,
    },
    TROLL_TONGUE: {
        item: 'Troll Tongue',
        category: IngredientCategory.AETHER,
        rarity: Rarity.RARE,
        cost: 66,
        weight: 0.1,
    },



    VAMPIRE_FANGS: {
        item: 'Vampire Fangs',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.RARE,
        cost: 150,
        weight: 0.1,
    },
    VAMPIRE_SALIVA: {
        item: 'Vampire Saliva',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 155,
        weight: 0.5,
    },
    VENDIGO_FUR: {
        item: 'Vendigo Fur',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 76,
        weight: 0.1,
    },
    VENDIGO_HEART: {
        item: 'Vendigo Heart',
        category: IngredientCategory.AETHER,
        rarity: Rarity.RARE,
        cost: 167,
        weight: 1,
    },
    VENOM_EXTRACT: {
        item: 'Venom Extract',
        category: IngredientCategory.CAELUM,
        rarity: Rarity.UNCOMMON,
        cost: 38,
        weight: 0.1,
    },
    VERBENA: {
        item: 'Verbena',
        category: IngredientCategory.SOL,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 18,
        weight: 0.1,
    },



    WERECAT_TEETH: {
        item: 'Werecat Teeth',
        category: IngredientCategory.REBIS,
        rarity: Rarity.RARE,
        cost: 88,
        weight: 0.1,
    },
    WEREWOLF_SALIVA: {
        item: 'Werewolf Saliva',
        category: IngredientCategory.HYDRAGENUM,
        rarity: Rarity.RARE,
        cost: 60,
        weight: 0.1,
    },
    WHITE_MYRTLE_PETALS: {
        item: 'White Myrtle Petals',
        category: IngredientCategory.VITRIOL,
        DC: 12,
        maxAmount: 10,
        rarity: Rarity.COMMON,
        cost: 8,
        weight: 0.1,
    },
    WINE_STONE: {
        item: 'Wine Stone',
        category: IngredientCategory.REBIS,
        DC: 18,
        maxAmount: 3,
        rarity: Rarity.RARE,
        cost: 88,
        weight: 0.5,
    },
    WING_MEMBRANE: {
        item: 'Wing Membrane',
        category: IngredientCategory.REBIS,
        rarity: Rarity.RARE,
        cost: 36,
        weight: 0.5,
    },
    WOLFS_ALOE_LEAVES: {
        item: 'Wolf\'s Aloe Leaves',
        category: IngredientCategory.SOL,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 39,
        weight: 0.1,
    },
    WOLFSBANE: {
        item: 'Wolfsbane',
        category: IngredientCategory.VERMILION,
        DC: 15,
        maxAmount: 6,
        rarity: Rarity.UNCOMMON,
        cost: 9,
        weight: 0.1,
    },
    WYVERN_EGG: {
        item: 'Wyvern Egg',
        category: IngredientCategory.FULGUR,
        rarity: Rarity.RARE,
        cost: 150,
        weight: 2,
    },
    WYVERN_EYE: {
        item: 'Wyvern Eye',
        category: IngredientCategory.SOL,
        rarity: Rarity.RARE,
        cost: 75,
        weight: 0.1,
    },
}